export default __webpack_public_path__ + "static/media/BaiJamjuree-Regular.08c1d38e.ttf";